export function fmt(cents: number, opts: { showCents?: boolean; showSign?: boolean } = {}): string {
  const { showCents = true, showSign = false } = opts;
  const neg = cents < 0;
  const abs = Math.abs(cents);
  const dollars = abs / 100;
  const str = showCents ? dollars.toFixed(2) : Math.round(dollars).toString();
  const [whole, dec] = str.split(".");
  const withCommas = (whole ?? "0").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formatted = dec ? `${withCommas}.${dec}` : withCommas;
  const sign = neg ? "-" : showSign ? "+" : "";
  return `${sign}$${formatted}`;
}

export function dollarsToCents(dollarStr: string): number {
  if (!/^-?\d+(\.\d{1,2})?$/.test(dollarStr)) {
    throw new Error(`dollarsToCents: invalid value "${dollarStr}"`);
  }
  const neg = dollarStr.startsWith("-");
  const positive = neg ? dollarStr.slice(1) : dollarStr;
  const [whole, frac = ""] = positive.split(".");
  const padded = (frac + "00").slice(0, 2);
  const cents = Number(whole) * 100 + Number(padded);
  return neg ? -cents : cents;
}
